module.exports = __webpack_public_path__ + "img/leader_en.d895f246.svg";